import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';

import { getSavedItemsAmount, extractVinsWithLeads } from 'site-modules/shared/components/profile/utils/extract-helper';

import { InsiderPageTitleHeadingComponent } from './insider-page-title-heading-component';

function InsiderPageHeaderComponent({ idmData = {}, showItemsCount = false, slug = '' }) {
  const saveItemsTotalAmount = getSavedItemsAmount(idmData);
  const savedItemsAmountBySlug = saveItemsTotalAmount[slug];
  const contactedItemsAmount = Object.keys(extractVinsWithLeads(idmData)).length;

  return (
    <Fragment>
      <InsiderPageTitleHeadingComponent />
      {showItemsCount && savedItemsAmountBySlug > 0 && contactedItemsAmount > 0 && (
        <div className="text-gray-darker d-md-inline-block mb-0_75 mb-md-1">
          {savedItemsAmountBySlug} saved, {contactedItemsAmount} contacted
        </div>
      )}
    </Fragment>
  );
}

InsiderPageHeaderComponent.propTypes = {
  idmData: PropTypes.shape({}),
  slug: PropTypes.string,
  showItemsCount: PropTypes.bool,
};

const mapStateToProps = state => ({
  idmData: get(state, 'profile.data.idm'),
});

export const InsiderPageHeader = connect(mapStateToProps)(InsiderPageHeaderComponent);
